import { Box, IconButton, styled } from '@mui/material';

interface StyledIconButtonProps {
  isPlayIconEnlarged?: boolean;
}

export const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'isPlayButtonEnlarged',
})<StyledIconButtonProps>(
  ({ theme, isPlayIconEnlarged: isPlayButtonEnlarged }) => ({
    borderRadius: '50%',
    width: isPlayButtonEnlarged ? theme.spacing(7) : theme.spacing(5),
    height: isPlayButtonEnlarged ? theme.spacing(7) : theme.spacing(5),
    backgroundColor: isPlayButtonEnlarged ? theme.palette.grey[800] : 'unset',
    '&:hover': {
      backgroundColor: isPlayButtonEnlarged
        ? theme.palette.grey[700]
        : theme.palette.grey[800],
    },
    fontSize: 80,
  })
);

interface StyledLoadingSpinnerContainerProps {
  isPlayIconEnlarged?: boolean;
}

export const StyledLoadingSpinnerContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isPlayButtonEnlarged',
})<StyledLoadingSpinnerContainerProps>(
  ({ theme, isPlayIconEnlarged: isPlayButtonEnlarged }) => ({
    width: isPlayButtonEnlarged ? theme.spacing(7) : theme.spacing(5),
    height: isPlayButtonEnlarged ? theme.spacing(7) : theme.spacing(5),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  })
);
